import { competitionList } from '../constant/RegisterPageConst';

const categoryLabels = new Map(Object.values(competitionList).map(label => [label.toLowerCase(), label]));

// Summarize complete group membership, independent of roster/search filters.
export const getGroupRegistrantSummary = (registrants = []) => {
    const events = new Map([['APCS2025', 0], ['APCS2026', 0]]);
    const categories = new Map();
    const teachers = new Set();
    const teachersByEvent = new Map();
    registrants.forEach(registrant => {
        // Missing documents are placeholders, not legacy APCS2025 registrations.
        const eventId = registrant.missing ? 'Unknown event' : registrant.eventId || 'APCS2025';
        const teacherName = !registrant.missing && typeof registrant.teacherName === 'string'
            ? registrant.teacherName.trim().toLocaleLowerCase() : '';
        if (teacherName) {
            teachers.add(teacherName);
            if (!teachersByEvent.has(eventId)) teachersByEvent.set(eventId, new Set());
            teachersByEvent.get(eventId).add(teacherName);
        }
        const rawCategory = String(registrant.competitionCategory || '').trim();
        const categoryKey = registrant.missing ? 'registrant unavailable' : rawCategory.toLowerCase() || 'not set';
        if (!categories.has(categoryKey)) categories.set(categoryKey, {
            label: registrant.missing ? 'Registrant unavailable' : categoryLabels.get(categoryKey) || rawCategory || 'Not set',
            total: 0,
            events: {},
        });
        events.set(eventId, (events.get(eventId) || 0) + 1);
        const category = categories.get(categoryKey);
        category.total += 1;
        category.events[eventId] = (category.events[eventId] || 0) + 1;
    });
    return {
        total: registrants.length,
        totalTeachers: teachers.size,
        events: [...events].map(([eventId, count]) => ({
            eventId, count, teacherCount: teachersByEvent.get(eventId)?.size || 0,
        })),
        categories: [...categories.values()].sort((a, b) => a.label.localeCompare(b.label)),
    };
};
